import React from "react";
import { Tick, ZohoInstallImg } from "../../../../../assets";
import { MdMenuBook } from "react-icons/md";
import { ZohoFeatures } from "../constants";

const IntegrationBenefits = () => {
  return (
    <section className="flex flex-col gap-4 my-4">
      <p className="text-gray-500 my-2 text-center">
        Connect CausalFunnel with your CRM. Create, update contacts, send
        transcripts from CausalFunnel to Zoho.
      </p>
      <div className="flex gap-8 flex-col xl:flex-row">
        <div className="w-full flex-1">
          <img src={ZohoInstallImg} alt="Zoho Installation" />
        </div>

        <div className="flex flex-col gap-3 flex-1">
          <h3 className="text-xl font-semibold py-3 border-bottom">
            Integration benefits
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {ZohoFeatures.map((item, index) => (
              <FeatureItem {...item} key={index} />
            ))}
          </div>
        </div>
      </div>

      <a
        href="https://www.causalfunnel.com/blog"
        target="_blank"
        rel="noreferrer noopener"
        className="text-indigo-600 hover:underline flex items-center gap-2"
      >
        <MdMenuBook className="text-2xl" />
        <p>How to install Zoho?</p>
      </a>
    </section>
  );
};

export default IntegrationBenefits;

const FeatureItem = ({ title, desc }) => {
  return (
    <div className="flex gap-2">
      <div className="">
        <Tick className=" text-green-600" />
      </div>
      <div>
        <h3 className="font-bold text-[14px]">{title}</h3>
        <p className="text-gray-500 text-[14px]">{desc}</p>
      </div>
    </div>
  );
};
